import { render, staticRenderFns } from "./ementasEletivas.vue?vue&type=template&id=08bb796a"
import script from "./ementasEletivas.vue?vue&type=script&lang=js"
export * from "./ementasEletivas.vue?vue&type=script&lang=js"
import style0 from "./ementasEletivas.vue?vue&type=style&index=0&id=08bb796a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports